YUI().use("anim", "transition", "event-move", function(Y) {

    "use strict";

    var $ = Y.one,
        DOT = ".",
        HASH = "#",
        BODY = "body",
        BANNER_ID = "ksu-banner",
        KSU_INNER_WRAPPER = $("#ksu-inner-wrapper"),
        UNIT_BAR_ID = "ksu-unitbar",
        UNIT_MENU_CLASS = "ksu-unit-menu",
        UNIT_MENU_LINK_CLASS = "ksu-unit-menu-link",
        MENU_OPEN_CLASS = "ksu-menu-open",
        UNIT_ACTIVE_CLASS = "ksu-unit-active",
        HORIZ_MENU_CLASS = "ksu-horiz-menu",
        HORIZ_ACTIVE_CLASS = "ksu-horiz-active",
        HORIZ_MENU_BAR_CLASS = "ksu-horiz-bar",
        MAIN_CONTENT_CLASS = "ksu-main-content",
        SIDEBAR_CLASS = "ksu-sidebar",
        SIDEBAR_SECONDARY_CLASS = "ksu-sidebar-secondary",
        UNIT_MENU_NOHIGHLIGHT_CLASS = "ksu-unit-menu-nohighlight",
        ACTIVE_CLASS = "ksu-active",
        PARENT_NODE = "parentNode",
        LAST_ITEM_CLASS = "ksu-last-item",
        menuwidth = "175",
        elementstoslideformenu,
        node,
        container,
        sidebar = $(DOT+SIDEBAR_CLASS),
        inside_sidebar,
        sidebarsecondary,
        menu,
        horizmenu,
        horizactive,
        unitactive,
        previoustime = 0,
        CLICK_THRESHOLD = 100,
        unitmenuvisible = false;

    /**
     * Show, hide, and toggle the unit menu.
     *
     *    showHeaderMenu(true)  -- shows the header menu
     *    showHeaderMenu(false) -- hides the header menu
     *    showHeaderMenu()      -- toggles the visibility of the header menu
     *
     */

    var showSidebar = function(state) {

        var now;

		// If the page has no sidebar, don't bother trying to show it.
        if (!sidebar) {
			return;
		}

        now = new Date().getTime();
        if ((now - previoustime) < CLICK_THRESHOLD) {
            return;
        }
        previoustime = now;

        /* If no state was passed in, toggle the state */
        if (!arguments.length) {
            state = !unitmenuvisible;
        }

        if (!elementstoslideformenu) {
            elementstoslideformenu = Y.all(HASH+BANNER_ID + ',' + DOT+MAIN_CONTENT_CLASS + ',' +
                                         DOT+SIDEBAR_SECONDARY_CLASS + '> div');
            // elementstoslideformenu = Y.all(DOT+MENU_SLIDE_WRAPPER_CLASS);
            //elementstoslideformenu = Y.all(HASH+BANNER_ID);
        }
        //Y.all(HASH+BANNER_ID).setStyle('margin-left', state ? '10px' : '0');
        Y.one(BODY).toggleClass(MENU_OPEN_CLASS, state);
        sidebar.transition({
            easing: 'linear',
            duration: 0.25,
            left: (state ? '5px' : '-'+menuwidth+'px')
        });
        unitmenuvisible = state;

        elementstoslideformenu.transition({
            easing: 'linear',
            duration: 0.25,
            left: (state ? (parseInt(menuwidth,10)+5)+'px' : 0)
        });

        // Y.all(HASH+BANNER_ID).transition({
        //      easing: 'linear',
        //      duration: 0.25,
        //      left: (state ? (parseInt(menuwidth,10)+15)+'px' : '0')
        //    });
    };

    /**
     * Handle clicks on the unit menu icon.
     *
     */
    var clickUnitMenu = function(evt) {

        evt.halt();

        /*
         * Then toggle the visibility of the menu.
         */
        showSidebar();
    };


    /**
     * Handle click events on the document body.
     *
     * In general, clicks outside of any sensitive area turn off the header submenu
     * and the signin box.
     */
    var clickBody = function(evt) {
        var target = evt.target;
        //console.log("Body click");


        /*
         * Similarly, if the sidebar is visible, and the click wasn't inside it,
         * then turn it off.
         */
        inside_sidebar = sidebar && sidebar.contains(target);
        if (unitmenuvisible  &&  !inside_sidebar) {
            //console.log("click", evt._wrapper.domkey);
            showSidebar(false);
        }
    };


    var scoreMenuItem = function(choice, loc, locpaths) {
        var i,
            score = 0,
            regexUrl = /^((?:https?|file|ftp):)\/\/((?:(?:[a-z\d](?:[a-z\d-]*[a-z\d])*)\.)+[a-z]{2,})(?::(\d*))?(\/[^\?#]*)/,
            url, path,
            matches, choicepaths, maxpaths;

        url = choice.get('href');   // Note: This URL has already been made absolute

        if (!url) {
            // There is no HREF attribute.  This entry should never match.
            return 0;
        }
        url = url.replace(/\/index\.html$/, "/");

        matches = regexUrl.exec(url);
        if (matches) {
            // The URL matched the absolute URL regex, so the protocol, hostname, and port must be checked.

            // If there is no port, the regex returns undefined, but window.location.port is the null string.
            if (typeof matches[3] === 'undefined') {
                matches[3] = "";
            }
            if (matches[1] !== loc.protocol  ||  matches[2] !== loc.hostname  ||  matches[3] !== loc.port) {
                return 0;
            }
            path = matches[4];
        } else {
            path = url;
        }

        /*
         * If we made it this far, the protocol, hostname, and port match
         */
        choicepaths = path.replace(/^\//g, "").replace(/\/$/g, "");
        choicepaths = choicepaths.split("/");
        //choicepaths.shift();
        maxpaths = choicepaths.length;
        //console.log("Choicepaths", choicepaths);
        //console.log("Locpaths", locpaths);

        score = 0;
        if (maxpaths <= locpaths.length) {

            score = maxpaths + 1;
            for (i = 0; i < maxpaths; i++) {
                if (choicepaths[i] !== locpaths[i]) {
                    score = 0;
                    break;
                }
            }

        }

        //console.log("Scoring", url, !!url, loc, locpaths, "==>", score);
        return score;
    };


    var findLastItem = function(node) {

        var next, submenu;

        //console.log("recursing", node);
        if (!node) {
            return null;
        }

        /*
         * If the node has a later sibling, then move to that node.
         */
        if (node.next()) {
            while ((next = node.next())) {    // Extra parentheses placate jshint about the assignment
                node = next;
            }
            return node;
        }

        /*
         * Check to see if we have a submenu.
         */
        submenu = node.all("> ul > li");

        /*
         * If there is no submenu, we've gone as far as we can.
         */
        if (submenu.isEmpty()) {
            return node;
        }

        /*
         * Step down to the submenu item marked as active, if it exists.
         * If none is marked as active, then just use the last submenu item.
         */
        next = submenu.filter(DOT + ACTIVE_CLASS);
        if (next.isEmpty()) {
            return submenu.item(submenu.size()-1);
        }

        return findLastItem(next.item(0));

    };


    var highlightMenuItem = function(menu, activeclass) {
        var active, choices, maxmatch, maxscore, loc, splitpaths, parent;

        console.log("Highlighting menu", menu);
        /*
         * Abort if no menu was specified, or if the page is being loaded inside the CMS.
         */
        if (!menu || window.location.hostname==="www.omniupdate.com") {
            return null;
        }

        active = null;

        // If the menu isn't marked as "hands-off"...
        if (!menu.hasClass(UNIT_MENU_NOHIGHLIGHT_CLASS)) {
            // ...and there isn't anything already marked as active.
            active = menu.one(DOT+ACTIVE_CLASS);
            if (!active) {
                maxmatch = null;
                maxscore = 0;
                choices = menu.all('li>a');
                loc = window.location;
                splitpaths = location.pathname.toString().replace(/\/index\.html$/,"");
                splitpaths = splitpaths.replace(/^\//g, "").replace(/\/$/g, "");
                splitpaths = splitpaths.split('/');
                //splitpaths.shift();
                choices.each(function(choice) {
                    var score = scoreMenuItem(choice, loc, splitpaths);
                    if (score > maxscore) {
                        maxmatch = choice;
                        maxscore = score;
                    }
                });

               /*
                * If there was anything that matched at all, then add ACTIVE_CLASS to that node,
                * the A element, and also all LI and UL elements up the DOM tree until, but not
                * including, the original menu node passed into this method.
                */
                if (maxscore && maxmatch) {
                    //console.log("Found a match", maxmatch);
                    maxmatch.addClass(ACTIVE_CLASS);
                    active = maxmatch;
                    parent = maxmatch.get(PARENT_NODE);
                    while (parent && !parent.compareTo(menu)) {
                        parent.addClass(ACTIVE_CLASS);
                        parent = parent.get(PARENT_NODE);
                    }
                }
            }

        }

        if (active && activeclass) {
            KSU_INNER_WRAPPER.addClass(activeclass);
        }

        return active;
    };


    var tagLastItem = function(menu) {
        var lastitem;


        /*
        * The code below doesn't check to see if no elements are found,
        * and it may try to call methods of null, the JavaScript equivalent
        * if Java's Null Pointer Exception.
        *
        * This is trapped by the try-catch, and all is OK because if there is no
        * menu, or no active item, or no A element at the end, nothing is tagged.
        * At worst, the visual display will be off.
        */
        try {
            node = menu.one("> .ksu-active") || menu.one("li");

            lastitem = findLastItem(node);
            //console.log("Lastitem", lastitem);
            lastitem.addClass(LAST_ITEM_CLASS);
            lastitem.one("a").addClass(LAST_ITEM_CLASS);
        } catch (e) {
            /* Nothing */
        }
    };

    /*
     * Highlight the proper menu items.
     */
    horizmenu = $(DOT+HORIZ_MENU_CLASS);
    horizactive = highlightMenuItem(horizmenu, HORIZ_ACTIVE_CLASS);
    menu = $(DOT+UNIT_MENU_CLASS);
    unitactive = highlightMenuItem(menu, UNIT_ACTIVE_CLASS);
    //   console.log("active:", horizactive, unitactive);
    if (horizmenu) {
        // This is kinda silly now that the bar always appears if the menu appears.
        horizmenu.addClass(HORIZ_MENU_BAR_CLASS);
    }
    tagLastItem(menu);

    if (sidebar && horizmenu) {
        sidebar.prepend(horizmenu.cloneNode(true));
    }

    /*
     * If it doesn't already exist, add a link for the unit menu icon.
     */
    node = $(HASH+UNIT_BAR_ID);
    if (node && !node.one(DOT+UNIT_MENU_LINK_CLASS)) {
        node.prepend("<button class='"+UNIT_MENU_LINK_CLASS+"' aria-label='open menu'><span></span></button>");
    }

    /*
     * Add event handlers for the functional parts of the page.
     */
    Y.on('click', clickUnitMenu, DOT+UNIT_MENU_LINK_CLASS);
    Y.on("click", clickBody, "body");

    /*
    * Wrap sidebar, main-content, and sidebar-secondary in a DIV.
    */
    container = Y.one("#ksu-inner-wrapper");

    sidebarsecondary = $(DOT+SIDEBAR_SECONDARY_CLASS);
});
